/**
 * @template T
 * @param {Array<T>} xs
 * @return {boolean}
 */
const isNonEmptyArray = (xs) => {
  return Array.isArray(xs) && xs.length > 0
}

/**
 * @param {ReturnType<typeof import('../actions/project')._setConflictResolutionData>} action
 * @return {boolean}
 */
export const conflictResolutionModalShouldBeOpen = (action) => {
  return (
    isNonEmptyArray(action?.localOnly?.notes) ||
    isNonEmptyArray(action?.localOnly?.characters) ||
    isNonEmptyArray(action?.localOnly?.places) ||
    isNonEmptyArray(action?.localOnly?.tags) ||
    isNonEmptyArray(action?.localOnly?.books) ||
    isNonEmptyArray(action?.localOnly?.familyTrees) ||
    isNonEmptyArray(action?.changedLocalAndOnline?.notes) ||
    isNonEmptyArray(action?.changedLocalAndOnline?.characters) ||
    isNonEmptyArray(action?.changedLocalAndOnline?.places) ||
    isNonEmptyArray(action?.changedLocalAndOnline?.tags) ||
    isNonEmptyArray(action?.changedLocalAndOnline?.books) ||
    isNonEmptyArray(action?.changedLocalAndOnline?.familyTrees) ||
    action.seriesDiff !== null
  )
}
